export const API_PATH = "https://api.ease-gulf.com";

export const STORAGE_TYPE = {
    LOCAL_STORAGE: "localStorage",
    SESSION_STORAGE: "sessionStorage",
};
